import React from 'react';
import { useEffect } from 'react';
import Layout from '../components/Layout';

const TermsAndConditions = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-b from-[#2A382A] via-[#2A382A] to-[#1F2B1F] pt-32 pb-16">
        <div className="container max-w-4xl mx-auto px-4 md:px-8">
          <div className="bg-[#1F2B1F]/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 shadow-xl border border-white/10">
            <h1 className="font-barrio text-4xl md:text-5xl mb-8 text-white">Terms & Conditions</h1>
          
            <div className="legal-content">
              <p>Welcome to sierpefrogs.com!</p>

              <p>These terms and conditions outline the rules and regulations for the use of Sierpe Frogs's Website, located at https://sierpefrogs.com.</p>

              <p>By accessing this website we assume you accept these terms and conditions. Do not continue to use sierpefrogs.com if you do not agree to take all of the terms and conditions stated on this page.</p>

              <h2>Cancellation Policies</h2>
              <p>If you want the full amount paid to be reimbursed, you must cancel at least 48 hours before the start date of the activity. In this experience there must be a minimum number of travelers. In the unlikely event of canceling because this minimum is not reached, you will be offered another date, another activity or a full refund of the money paid.</p>
              <p>If the activity you have booked is canceled due to adverse weather conditions, we will refund 100% of the amount you have paid.</p>

              <h2>Payment Policies</h2>
              <p>Our platform offers you the option of paying with a Credit Card: The prices shown on the website are expressed in US dollars, local currency.</p>
              <p>Payment can be made through credit card (Visa and Mastercard) or other payment methods accepted the PayPal.</p>
              <p>All products and services must be paid for before being provided.</p>

              <h2>Booking Policies</h2>
              <p>The rates, shown on the website are valid only at the time of their quotation, they may change according to the conditions of each provider as long as they have not been reserved and confirmed. Reservations are subject to availability until confirmed. The reservation is considered confirmed when the corresponding payment has been covered and there is an electronic reservation invoice with a confirmation number. To avoid any setbacks, you must present the corresponding coupon electronically or in print at the time of requesting your paid service, as proof of reservation.</p>
              <p>The rates can vary without prior notice due a change on parks entrance fees.</p>
              <p>All reservations and/or cancellations must be confirmed and can be changed without reason whatsoever by the agency.</p>
              <p>No shows will immediately be informed to the agency and have no refund.</p>
              <p>A guest not following recommendations or safety advises of the park or given by our tour guide during the safety talk before starting the tour, can cause the tour cancellation with no refund.</p>

              <h2>License</h2>
              <p>Unless otherwise stated, Sierpe Frogs and/or its licensors own the intellectual property rights for all material on sierpefrogs.com. All intellectual property rights are reserved.</p>

              <h2>Hyperlinking to our Content</h2>
              <p>The following organizations may link to our Website without prior written approval:</p>
              <ul>
                <li>Government agencies;</li>
                <li>Search engines;</li>
                <li>News organizations;</li>
                <li>Online directory distributors;</li>
                <li>System wide Accredited Businesses.</li>
              </ul>

              <h2>Content Liability</h2>
              <p>We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website.</p>

              <h2>Disclaimer</h2>
              <p>To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:</p>
              <ul>
                <li>limit or exclude our or your liability for death or personal injury;</li>
                <li>limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
                <li>limit any of our or your liabilities in any way that is not permitted under applicable law; or</li>
                <li>exclude any of our or your liabilities that may not be excluded under applicable law.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TermsAndConditions;